// src/pages/DownloadPopup.tsx
import { Button, Box, Typography } from "@mui/material";
import { saveAs } from "file-saver";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useEstimateApi } from "../../hooks/useEstimateApi.ts";
import { COMPANY_IN_CHARGE_TYPE, defaultEstimateDto, EstimateDto } from "../../contracts/estimates/types.ts";

export default function DownloadPopup() {
  const [search] = useSearchParams();
  const key = search.get('key')!;
  const [downloading, setDownloading] = useState(false);
  const [formData, setFormData] = useState<EstimateDto>(defaultEstimateDto);
  const { downloadXlsx, downloadPdf,
    downloadXlsxMun, downloadPdfMun,
    downloadXlsxComparison, downloadPdfComparison
   } = useEstimateApi();

    useEffect(() => {
        console.log("[popup] send POPUP_READY");
        window.opener?.postMessage({ type: "POPUP_READY" }, "*");
    }, []);

  /* 1) 부모에게 "POPUP_READY" 알림 */
  useEffect(() => {
    const onMsg = (e: MessageEvent) => {
      if (e.source !== window.opener) return;
      console.log("[popup] received", e.data);
      setFormData(e.data.payload);
    };
    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
  }, []);

  const downloadXslsFunction = async () => {
    if (!formData) return;
    setDownloading(true);
    try {
      if (formData.companyInCharge == COMPANY_IN_CHARGE_TYPE[0]){
        await downloadXlsx(formData)
      } else if (formData.companyInCharge == COMPANY_IN_CHARGE_TYPE[1]) {
        await downloadXlsxMun(formData)
      } else {
        await downloadXlsxComparison(formData)
      }
      localStorage.removeItem(key)
      setTimeout(() => window.close(), 1000);   // 팝업 자동 종료
    } catch (e) {
      alert("다운로드 실패: " + (e as Error).message);
      setDownloading(false);
    }
  };

  const downloadPdfFunction = async () => {
    if (!formData) return;
    setDownloading(true);
    try { 
      if (formData.companyInCharge == COMPANY_IN_CHARGE_TYPE[0]){
        await downloadPdf(formData)
      } else if (formData.companyInCharge == COMPANY_IN_CHARGE_TYPE[1]) {
        await downloadPdfMun(formData)
      } else {
        await downloadPdfComparison(formData)
      }
      localStorage.removeItem(key)
      setTimeout(() => window.close(), 1000);   // 팝업 자동 종료
    } catch (e) {
      alert("다운로드 실패: " + (e as Error).message);
      setDownloading(false);
    }
  };
  
  return (
    <Box
      sx={{height:"100vh",display:"flex",flexDirection:"column",
           alignItems:"center",justifyContent:"center",gap:2}}
    >
      <Typography variant="h6">
        견적서 다운로드
      </Typography>
      <Button
        variant="contained"
        size="large"
        disabled={downloading || !formData}
        onClick={downloadXslsFunction}
      >
        {downloading ? "다운로드 중..." : "엑셀 다운로드"}
      </Button>

       <Button
        variant="contained"
        size="large"
        disabled={downloading || !formData}
        onClick={downloadPdfFunction}
      >
        {downloading ? "다운로드 중..." : "PDF 다운로드"}
      </Button>
    </Box>
  );
}
